module.exports = __webpack_public_path__ + "img/img2.dc2a3b3a.png";